module.exports = __webpack_public_path__ + "img/9.44d6c893.webp";